import React, { useContext } from "react"
import prepolicyServingPdf from '../documents/pre_policy_issuance_process.pdf';
import { navigate } from "gatsby";
import { getSourceFromChannel } from "./services/helperFunctions"
import { JourneyContext } from "./context/journeyContext"

const Footer = () => {
  const [journeyState, setJourneyState] = useContext(JourneyContext);
  if(!journeyState?.channel) {
    return null;
  }
  if(["EQUITAS", "equitas", "36"].includes(journeyState?.channel)) {
    return null;
  }
  return (
    <>
      <div className="clearfix"></div>
      {/* <!--Footer-design--> */}
      <div className="mobile-footer-view">
        <div className="footer-design">
          <div className="mx-auto container row footer-class-for-inline">
            <div className="col-lg-3 col-md-12">
              <h2>Customer Information</h2>
              <ul className="list-inline link-footer step1-footer">
                <li>
                  {typeof window !== "undefined" && <a href={new URL(`${window.location.origin}/${window.location.pathname.split("/").filter(Boolean)[0]}/policy_servicing_process.pdf`,window.location.origin).href} target = "_blank" className="">
                    Policy Servicing &gt;
                  </a>}
                </li>
                <li>
                  <a href={prepolicyServingPdf} target = "_blank"> Pre-policy Issuance Process &gt;</a>
                </li>
                <li>
                  <a aria-hidden="true" onClick={e=>{navigate("/disclaimers")}}>Disclaimers &gt; </a>{" "}
                </li>
              
                
                <li>
                  {typeof window !== "undefined" && <a href={new URL(`${window.location.origin}/${window.location.pathname.split("/").filter(Boolean)[0]}/Claims_Manual.pdf`,window.location.origin).href} target = "_blank" className="">
                      Claims Manual &gt;
                  </a>}
                </li>

                </ul>
            </div>
            <div className="col-lg-4 col-md-12 contact-us contact-us-new" style={{"paddingLeft":"60px"}}>
              <h2>Contact Us</h2>
              <ul className="list-inline link-footer">
                <li>
                  <p>
                    <span
                      className="fa fa-envelope"
                      style={{color:"var(--lumiq-footer-icon-color)", marginRight:"1px"}}
                    ></span>{" "}
                    {getSourceFromChannel(journeyState.channel) === "U" ? "onlineterm@canarahsbclife.in" : "customerservice@canarahsbclife.in"}
                  </p>
                </li>
                <li>
                  <a >
                    <span
                      className="fa fa-phone"
                      style={{color:"var(--lumiq-footer-icon-color)", marginRight:"5px"}}
                    ></span>{" "}
                    {getSourceFromChannel(journeyState.channel) === "U" ?  "1800-258-5899" : "1800-891-0003"}
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-5  col-md-12">
              <h2>Office</h2>
              <ul className="list-inline link-footer">
                <li>
                  Head Office: 139 P, Sector 44, Gurugram - 122003, Haryana,
                  India
                  <br />
                  www.lifeinscouncil.org | IRDAI Registration no: 136.
                  www.irdai.gov.in
                </li>
              </ul>
            </div>
            <div className="col-lg-12 col-md-12 pt-5">
              <p className="brd-ft">
                {" "}
                BEWARE OF SPURIOUS / FRAUD PHONE CALLS!
                <br />
                IRDAI is not involved in activities like selling insurance
                policies, announcing bonus or investment of premiums. Public
                receiving such phone calls are requested to lodge a police
                complaint.
              </p>
            </div>
          </div>
        </div>
        <div className="footer-bottom-design">
          <div className="container">
            <p className="text-center">
              © {`${new Date().getFullYear()}–${new Date().getFullYear() + 1}`} Canara HSBC Life Insurance Company Limited
            </p>
          </div>
        </div>
      </div>
      {/* <!--Footer-design-->  */}
    </>
  )
}

export default Footer
